import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AuctionFilter } from '../../models/auction-filter';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { HttpClient } from '@angular/common/http';
import { skip } from "rxjs/operators";

import { environment } from '../../../../../environments/environment';
import { LoggingService } from '../../../../services/logging.service';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-home-main-modal-manager',
  templateUrl: './home-main-modal-manager.component.html',
  styleUrls: ['./home-main-modal-manager.component.sass']
})
export class HomeMainModalManagerComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];
  private opened = false;


  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('managerCheckInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;

  modelAuctionFilter: AuctionFilter = new AuctionFilter();

  dtOptionsManager: DataTables.Settings = {};
  dataSetManagers: any;
  checkedManagers: string[];

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) {
    this.checkedManagers = [];
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'kam' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedManagers = [];

            if (key !== "all") {
              this.onAuctionFilter();
            }
          }
        })
    );

    const that = this;
    
    $('#modalKam').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });

    this.dtOptionsManager = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      order: [1],
      deferLoading: 0,
      dom: 'ti',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: 'Нет совпадающих значений для поиска',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        that.http.post<DataTablesResponse>(`${apiServer}/manager`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetManagers = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [

        { orderable: false },
        { data: 'KAM', name: 'KAM', orderable: false }

      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onSelectedRow(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedManagers.push(value);
      } else {
        for (let i = 0; i < this.checkedManagers.length; i++) {
          if (this.checkedManagers[i] === value) {
            this.checkedManagers.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedManagers.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedManagers.length; i++) {
            if (that.checkedManagers[i] === item.nativeElement.value) {
              that.checkedManagers.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalManagerComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  onAuctionFilter() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalManagerComponent.onAuctionFilter', null, 'Auction filter started');
      
      this.modelAuctionFilter.kam = this.checkedManagers.join(",");
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalManagerComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalManagerComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-manager/home-main-modal-manager.component.ts